




import Vue from "vue";
import marked from "marked";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class MarkDown extends Vue {
  @Prop({ default: "" })
  public text!: string;

  public created() {
    marked.setOptions({
      breaks: true
    });
  }

  public mounted() {
    this.$emit("mounted");
  }

  public get compiledMarkdown() {
    const text = this.$slots?.default?.[0]?.text || this.text;
    return marked(text);
  }
}
